import React from 'react'
import { Path } from 'react-native-svg'

import { createIcon } from '../../_gluestack/icon'

export const TaskInspectionRopeIcon = createIcon({
    viewBox: '0 0 24 24',
    path: (
        <Path
            fill='currentColor'
            fillRule='evenodd'
            d='M12.984 8.6V6.584h-1.968V8.6h1.968zm0 8.016v-6h-1.968v6h1.968zm-.984-15c1.824 0 3.512.456 5.064 1.368a9.463 9.463 0 0 1 3.552 3.552 9.819 9.819 0 0 1 1.368 5.064 9.819 9.819 0 0 1-1.368 5.064 9.463 9.463 0 0 1-3.552 3.552A9.819 9.819 0 0 1 12 21.584a9.819 9.819 0 0 1-5.064-1.368 9.642 9.642 0 0 1-3.552-3.576 9.775 9.775 0 0 1-1.368-5.04c0-1.808.456-3.488 1.368-5.04A9.826 9.826 0 0 1 6.96 2.984 9.775 9.775 0 0 1 12 1.616z'
        />
    ),
})

TaskInspectionRopeIcon.displayName = 'TaskInspectionRopeIcon'
